export class ApiError<T = unknown> extends Error {
  options?: T;
  status?: number;

  constructor(message: string, options?: T, status?: number) {
    super(message);
    this.options = options;
    this.status = status;
  }
}
